import RESIDENTIAL_PLAN_TYPES from '../../../../../Constants/ResidentialPlansStatus'
import { Grid, Select, MenuItem } from '@mui/material'

const ResidentialPlanTypeSelect = ({ handlerFilterResidentialPlans }) => {
  const residentialPlanTypeSelected = (event) => {
    handlerFilterResidentialPlans(event.target.value)
  }

  return (
    <Grid size={12} className="approve-button-container">
      <div>
        <label htmlFor="filter-rp">Show</label>
        <br />
        <Select
          id="filter-rp"
          variant="outlined"
          defaultValue={RESIDENTIAL_PLAN_TYPES.ALL}
          className="actions-field"
          onChange={residentialPlanTypeSelected}
          style={{ width: '200px', height: '40px' }}
        >
          <MenuItem value={RESIDENTIAL_PLAN_TYPES.ALL}>ALL</MenuItem>
          <MenuItem value={RESIDENTIAL_PLAN_TYPES.APPROVE}>APPROVE</MenuItem>
          <MenuItem value={RESIDENTIAL_PLAN_TYPES.NOT_APPROVE}>NOT APPROVE</MenuItem>
        </Select>
      </div>
    </Grid>
  )
}

export default ResidentialPlanTypeSelect
